<template>
  <div class="brand-filter">
    <button
      v-for="(option, option_index) in options"
      :key="`brand-${option_index}`"
      type="button"
      class="brand-filter__item"
      :class="{ 'brand-filter__item--active': option.selected }"
      :disabled="option.amount === 0"
      :aria-pressed="String(option.selected)"
      @click="toggle(option)"
    >
      <img
        class="brand-filter__logo"
        :src="`assets/images/alpitour/liveat-brands/${option.logo}`"
        :alt="option.text"
      />
    </button>
  </div>
</template>

<script>
  export default {
    name: 'brand-filter',

    props: {
      options: {
        type: Array,
        default: () => [],
      },
    },

    methods: {
      toggle(option) {
        if (option.amount === 0) {
          return;
        }
        const next = !option.selected;
        this.options.forEach((entry) => {
          entry.selected = false;
        });
        option.selected = next;
        this.$emit('filter', { key: 'brand', value: next });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .brand-filter {
    display: flex;
    flex-direction: column;
    gap: $grid-gutter-width / 3;
    margin-bottom: map-get($spacers, 2);

    &__item {
      appearance: none;
      margin: 0;
      color: inherit;
      font: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 42px;
      padding: $grid-gutter-width / 4 $grid-gutter-width / 2;
      background: none;
      border: 1px solid $gray-300;
      border-radius: $rounded-pill;
      transition: $transition-base;

      &:not(:disabled) {
        cursor: pointer;

        &:hover {
          background-color: $selected;
        }
      }

      &--active {
        border-color: var(--primary);
      }

      &:disabled {
        filter: grayscale(100);
        opacity: 0.5;
      }
    }

    &__logo {
      max-height: 18px;
      max-width: 100%;
      width: auto;
    }
  }
</style>
